<div class="space-y-3">
  <!-- Input Section -->
  @if (allowAdd() || allowSelectOnly()) {
    <div class="flex gap-2">
      <!-- Input field (hidden for select-only with no items) -->
      @if (!allowSelectOnly() || unselectedItems().length === 0) {
        <input
          hlmInput
          type="text"
          [placeholder]="placeholder()"
          [value]="inputValue()"
          [disabled]="disabled()"
          (input)="onInputChange($any($event.target).value)"
          (keydown)="onKeydown($event)"
          class="flex-1"
          [class.border-destructive]="inputError()"
        />
      }

      <!-- Add button -->
      @if (!allowSelectOnly() && allowAdd()) {
        <button
          hlmBtn
          type="button"
          [disabled]="!canAddButton() || disabled()"
          (click)="addTag()"
        >
          <ng-icon name="lucidePlus" class="w-4 h-4" />
          <span class="hidden sm:inline">Hinzufügen</span>
        </button>
      }
    </div>

    <!-- Input error -->
    @if (inputError()) {
      <p class="text-xs text-destructive">{{ inputError() }}</p>
    }

    <!-- Existing items dropdown (select-only mode) -->
    @if (allowSelectOnly() && unselectedItems().length > 0) {
      <div class="space-y-2">
        <p class="text-xs font-normal text-muted-foreground">
          Verfügbare {{ badgeLabel() | lowercase }}n
        </p>
        <div class="flex flex-wrap gap-2">
          @for (item of unselectedItems(); track item) {
            <button
              type="button"
              class="inline-flex items-center gap-2 px-3 py-2 bg-muted text-sm rounded-md hover:bg-muted/80 transition-colors"
              [disabled]="disabled()"
              (click)="selectExistingItem(item)"
            >
              <ng-icon name="lucidePlus" class="w-3 h-3" />
              {{ item }}
            </button>
          }
        </div>
      </div>
    }
  }

  <!-- Tags Display -->
  @if (displayTags().length > 0) {
    <div class="space-y-2">
      <p class="text-xs font-normal text-muted-foreground">
        {{ displayTags().length }}
        {{ displayTags().length === 1 ? badgeLabel() : badgeLabel() + "n" }}
      </p>
      <div class="flex flex-wrap gap-2">
        @for (tag of displayTags(); track tag) {
          <span
            hlmBadge
            variant="secondary"
            class="inline-flex items-center gap-2 pr-1"
            [attr.aria-label]="badgeLabel() + ': ' + tag"
          >
            {{ tag }}
            @if (allowRemove() && !disabled()) {
              <button
                type="button"
                (click)="removeTag(tag)"
                class="hover:opacity-70 transition-opacity flex justify-center items-center"
                [attr.aria-label]="badgeLabel() + ' entfernen: ' + tag"
              >
                <ng-icon name="lucideX" />
              </button>
            }
          </span>
        }
      </div>
    </div>
  }
</div>
